<template>
  <div id="title-bar" :class="{ stick: stick, 'always-stick': alwaysStick }">
    <b-navbar type="dark" toggleable="xl">
      <b-navbar-brand to="/">
        <div>Janine & Johannes</div>
        <div id="date">05.09.2020</div>
      </b-navbar-brand>

      <b-navbar-nav class="d-none">
        <b-nav-item to="/">Home</b-nav-item>
        <dropdown :class="{solid: stick}" toggle-text="Hochzeitsfeier" toggle-to="/galerie">
          <dropdown-group header="Dein Beitrag">
            <dropdown-item to="/upload">Foto-Upload</dropdown-item>
          </dropdown-group>
          <dropdown-divider/>
          <dropdown-group header="Sonstiges">
            <dropdown-item to="/galerie">Galerie</dropdown-item>
          </dropdown-group>
        </dropdown>
        <b-nav-item to="/galerie">Galerie</b-nav-item>
      </b-navbar-nav>

      <menu-toggle :class="{dark: stick}" @toggle="$emit('toggle-menu')"/>
    </b-navbar>
  </div>
</template>

<script>
import MenuToggle from '@/components/MenuToggle.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import DropdownDivider from '@/components/dropdown/DropdownDivider.vue';
import DropdownGroup from '@/components/dropdown/DropdownGroup.vue';
import DropdownItem from '@/components/dropdown/DropdownItem.vue';

export default {
  data() {
    return {
      stick: this.alwaysStick,
    };
  },

  props: {
    alwaysStick: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    alwaysStick(newVal, oldVal) {
      if (!newVal) {
        this.handleScroll();
      } else {
        this.stick = this.stick || newVal;
      }
    },
  },

  methods: {
    triggerPoint() {
      if (window.matchMedia('screen and (max-width: 450px)').matches) {
        return 200;
      }

      if (window.matchMedia('screen and (max-width: 767px)').matches) {
        return 250;
      }

      if (window.matchMedia('screen and (max-width: 1200px)').matches) {
        return 300;
      }


      return 450;
    },

    handleScroll() {
      if (!this.alwaysStick) {
        this.stick = window.scrollY > this.triggerPoint();
      }
    },

  },

  created() {
    document.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  },

  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    MenuToggle,
    Dropdown,
    DropdownDivider,
    DropdownGroup,
    DropdownItem,
  },
};
</script>

<style lang="scss">
  @import "../scss/variables";

  #title-bar {
    $ease-time: 400ms;

    position: sticky;
    top: 0;

    width: 100%;

    user-select: none;
    cursor: default;

    background-color: transparent;

    transition: background-color $ease-time ease-in-out,
    box-shadow $ease-time ease-in-out, border-bottom $ease-time ease-in-out;

    font-size: 1.4rem;
    letter-spacing: 0.125em;

    z-index: 20;

    @media only screen and (min-width: $breakpoint-md) {
      font-size: 2rem;
    }

    .navbar {
      background-color: transparent;

      padding: 0.5em 3rem;

      align-items: stretch;

      .navbar-brand,
      .nav-item > .nav-link,
      .dropdown-nav-item > .dropdown-nav-toggle > a {
        color: white;

        transition: color $ease-time ease-in-out;
      }

      .navbar-brand {
        font-family: "Sitka Banner", serif;
        font-size: inherit;
        line-height: 1;
        text-decoration: none;

        margin-right: 0;

        flex: 1 1 auto;

        #date {
          font-size: 0.75em;
          margin-top: 0.5em;
        }
      }

      .navbar-brand,
      .navbar-nav {
        padding: 0.375rem 0;

        font-size: inherit;
        line-height: 1;
        text-decoration: none;
      }

      .navbar-nav {
        position: absolute;
        right: 2.5rem;

        height: calc(100% - 1em);

        .nav-item,
        .dropdown-nav-item {
          display: inline-flex;
          flex-direction: column;
          justify-content: center;
          line-height: 1;
          height: 100%;

          .nav-link,
          .dropdown-nav-toggle > a {
            font-family: "Sitka Subheading", serif;
            font-size: 0.75em;
            letter-spacing: 0.125em;

            padding: 0.5rem 1.25rem;

            &.router-link-exact-active {
              color: rgba(255, 255, 255, 0.7);
            }
          }
        }
      }

      #menu-toggle {
        position: absolute;
        top: 50%;
        right: 0.75rem;
        transform: translateY(-50%);

        @media only screen and (min-width: $breakpoint-md) {
          right: 1.25rem;
        }
      }

      @media only screen and (min-width: 1450px) {
        .navbar-nav {
          display: block !important;
        }

        #menu-toggle {
          display: none !important;
        }
      }
    }

    &.stick {
      background-color: $body-bg;

      box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.25);
      border-bottom: 1px solid #cacaca;

      .navbar {
        .navbar-brand {
          color: black;
        }

        .nav-item > .nav-link,
        .dropdown-nav-item > .dropdown-nav-toggle > a {
          color: black;

          &.router-link-exact-active {
            color: rgba(0, 0, 0, 0.5);
          }
        }


        .dropdown-nav-item > .dropdown-nav-toggle > a.router-link-active {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }

    &.always-stick {
      /*position: relative;*/
    }
  }
</style>
